<div class="sticky-nav">
	<header></header>
</div>
<div class="container">
    <router-outlet></router-outlet>
</div>
<footer></footer>